import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    codeText: {
      ...CommonFonts.darkBoldFont24,
    },
    storeNameText: {
      ...CommonFonts.darkBoldFont16,
    },
    addressText: {
      ...CommonFonts.darkFont12,
    },
    lastUpdatedText: {
      ...CommonFonts.darkFont10,
    },
    adjustButton: {
      "&.MuiButton-root": {
        fontSize: 16,
        fontWeight: "bold",
        textTransform: "none",
      },
    },
  })
);

export default useStyles;
